import SuccessRoundImage from '../../assets/images/success-round.webp';
import useTranslation from '../../localization/i18n.context';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import SuccessFeedbackScreen from '../../components/shared/SuccessFeedbackScreen/SuccessFeedbackScreen';
import { useEffect } from 'preact/hooks';
import CheckShieldIcon from '../../components/shared/Icons/CheckShieldIcon';
import { TrackingEvent } from '../../sdk/tracking.event';

export default function ResetPinSuccessPage() {
  const { t } = useTranslation();

  const closeWebview = () => {
    CloseWebviewEvent.finishSuccessfully();
  };

  useEffect(() => {
    TrackingEvent.trigger(
      TrackingEvent.Events.PIN_CHANGE_SUCCESS_SCREEN_SHOW,
      TrackingEvent.Sources.CAAS,
    );
  }, []);
  return (
    <SuccessFeedbackScreen
      onCloseClick={closeWebview}
      image={SuccessRoundImage}
      title={t('Your PIN was updated.')}
      text={t('Reset your PIN anytime from settings')}
      subtitle={t('Stay safe - never share your PIN number')}
      ctaAction={closeWebview}
      ctaText={t('Start shopping')}
      icon={<CheckShieldIcon />}
    />
  );
}
